import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Business } from '@app/modules/my-business/interfaces/business.interface';
import { environment } from '@env/environment';
import {
  AccountEditPayload,
  Connection,
  Session,
  TrackingCategory,
} from '@app/modules/businesses/models/accounting.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountingApiService {
  private readonly http = inject(HttpClient);

  #apiBase = `${environment.apiUrl}/operations/v2`;
  #businessesBase = `${environment.apiUrl}/businesses`;

  public createAccountingConnection() {
    return this.http.post<Session>(`${this.#apiBase}/accounting/create`, {});
  }

  public deleteAccountingConnection(id: Connection['id']) {
    return this.http.delete(`${this.#apiBase}/accounting/connections/${id}`);
  }

  public getAccountingConnections() {
    return this.http.get<Connection[]>(`${this.#apiBase}/accounting/connections`);
  }

  public createBusinessAccountingConnection(businessUuid: Business['uuid']) {
    return this.http.post<Session>(`${this.#businessesBase}/${businessUuid}/connections`, {});
  }

  public getAccountOptions(businessUuid: Business['uuid']) {
    return this.http.get(`${this.#businessesBase}/${businessUuid}/connections/available-accounts`);
  }

  public getTrackingCategories(id: number) {
    return this.http.get<TrackingCategory[]>(`${this.#apiBase}/accounting/${id}/available-tracking-categories`);
  }

  public getAccountingConnectionConfig(id: number) {
    return this.http.get<any>(`${this.#apiBase}/accounting/${id}/account-mapping`);
  }

  public saveAccountingConnectionConfig(id: number, data: AccountEditPayload) {
    return this.http.post<any>(`${this.#apiBase}/accounting/${id}/account-mapping`, data);
  }
}
